export { default as Card } from './Card';
export type { CardProps, CardVariant } from './Card';
